import React, { FC } from 'react';
import { Contact } from '../../interfaces/Contact';
import Content from '../Content';
import Section from '../../../../components/Section';

export interface AddressProps {
  contact: Contact;
}

const Address: FC<AddressProps> = ({ contact }) => {
  if (contact && (contact.name?.length > 0 || contact.address?.length > 0)) {
    const sectionName = contact.serviceCenter ? contact.name : contact.name?.join(' ') ?? null;
    return (
      <Section name={sectionName}>
        <Content lines={contact.address} />
      </Section>
    );
  }
  return null;
};

export default Address;
